module.exports = __webpack_public_path__ + "img/_54A2290_t.f4ef0fb3.jpg";